class TimeUtil {
  get currentYear() {
    return new Date().getFullYear()
  }
}

export default new TimeUtil()
